import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SITE } from "@/config/site";

/**
 * useSiteConfig — one-shot fetch of the admin-editable contact details
 * (phone, email, address). The hook returns the fetched row when
 * available, otherwise the compiled-in defaults from `SITE` so pages
 * never render an empty footer.
 *
 * Admin edits at /admin/site-contact take effect on the next page load.
 */
export function useSiteConfig() {
  const [cfg, setCfg] = useState({
    phone: SITE.phone,
    phoneRaw: SITE.phoneRaw,
    email: SITE.email,
    address: SITE.address,
  });

  useEffect(() => {
    api.get("/site-config").then((r) => {
      const d = r.data || {};
      // Only override the compiled defaults when the admin has actually saved
      // something — an empty string is preserved as intentional.
      setCfg((prev) => ({
        phone: d.phone || prev.phone,
        // Derive phoneRaw from the phone if the admin edited only the display
        // number — strips spaces and the leading "+".
        phoneRaw: d.phone ? d.phone.replace(/[^\d]/g, "") : prev.phoneRaw,
        email: d.email || prev.email,
        address: {
          ...prev.address,
          ...(d.address || {}),
        },
      }));
    }).catch(() => { /* fall back to SITE.js defaults silently */ });
  }, []);

  return cfg;
}
